import { type ContextMenuInputItem, type MenuAction } from '@/src/ui';

export type QuestionRendererOptions = {
    disabled?: boolean;
    showAudioButtons?: boolean;
    hidePrompt?: boolean;
    hideKeypad?: boolean;
    showLanguageToggle?: boolean;
    showScoring?: boolean;
    language?: 'en' | 'es';
    onRendererContextMenu?: (
        e: React.MouseEvent,
        choiceData: ContextMenuInputItem,
        rendererActions: MenuAction<ContextMenuInputItem>[]
    ) => void;
};
export const defaultOptions: QuestionRendererOptions = {
    disabled: false,
    showAudioButtons: false,
    hidePrompt: false,
    hideKeypad: false,
    showLanguageToggle: false,
    showScoring: false,
    language: 'en',
    onRendererContextMenu: undefined,
};
